import React from "react";
import Header from "../component/Header";

function Settings() {
  return (
    <div>
      <Header />
      <h1>hello world</h1>
    </div>
  );
}

export default Settings;
